import i18next from 'i18next'
import { HTTPError } from 'ky'
import { toast } from 'vue-sonner'
import { RouteParams } from 'vue-router'
import { middlewareContext, middlewareInstructions } from './types'
import { ACCESS_DENIED_STATUSES } from '~/constants/http'
import { ACCESS_RESTRICTED_TOAST_DELAY_MS } from '~/constants/ui'
import { ResourceParam } from '~/types/navigation'
import { RESOURCE_PARAMS } from '~/constants/permissions'

function fetchResource(param: ResourceParam, id: string) {
  const api = useHttpClient()
  switch (param) {
    case 'subId':
      return api.subscriptions.getSingle(id)
    case 'partnerId':
    case 'resellerId':
      return api.partners.getSingle(id)
    case 'customerId':
      return api.customers.getSingle(id)
    case 'eventId':
      return api.events.getSingle(id)
  }
}

function getParamId(params: RouteParams, param: ResourceParam) {
  const value = params[param]
  return Array.isArray(value) ? value[0] : value
}

export default async function hasResourceAccess(
  ctx: middlewareContext,
): Promise<middlewareInstructions> {
  const { to, from } = ctx

  const requestedResources = RESOURCE_PARAMS.map((param) => ({
    param,
    id: getParamId(to.params, param),
  })).filter(({ id }) => id)

  const sameScope = RESOURCE_PARAMS.every(
    (param) => getParamId(to.params, param) === getParamId(from.params, param),
  )

  if (!requestedResources.length || sameScope) return { to: { name: '' } }

  const appStore = useAppStore()
  try {
    appStore.startBarLoad()
    await Promise.all(
      requestedResources.map(({ param, id }) => fetchResource(param, id)),
    )
    return { to: { name: '' } }
  } catch (error) {
    if (
      !(error instanceof HTTPError) ||
      !ACCESS_DENIED_STATUSES.includes(error.response.status)
    ) {
      return { to: { name: '' } }
    }
    setTimeout(() => {
      toast.error(i18next.t('insufficientPermissions', { ns: 'errors' }))
    }, ACCESS_RESTRICTED_TOAST_DELAY_MS)
    return { to: { name: 'subscription-portal-subscriptions' } }
  } finally {
    appStore.endBarLoad()
  }
}
